<template>
  <div id="container">
    <div id="canvas">
      <div style="flex: auto">
        <el-steps :active="this.process" simple style="margin-top: 20px;">
          <el-step title="已就绪"/>
          <el-step title="压测中"/>
          <el-step title="停止中"/>
          <el-step title="已停止"/>
        </el-steps>
      </div>
      <el-divider content-position="left">趋势图</el-divider>
      <div class="panel-items">
        <div class="panel-item panel-item-line-4">
          <div class="panel-item-title">虚拟用户数</div>
          <div class="panel-item-line-drawer">
            <div id="user" class="metric"/>
          </div>
        </div>
        <div class="panel-item panel-item-line-4">
          <div class="panel-item-title">请求数/秒</div>
          <div class="panel-item-line-drawer">
            <div id="rps" class="metric"/>
          </div>
        </div>
        <div class="panel-item panel-item-line-4">
          <div class="panel-item-title">吞吐量/秒</div>
          <div class="panel-item-line-drawer">
            <div id="tps" class="metric"/>
          </div>
        </div>
        <div class="panel-item panel-item-line-4">
          <div class="panel-item-title">平均耗时</div>
          <div class="panel-item-line-drawer">
            <div id="elapsed-time" class="metric"/>
          </div>
        </div>
      </div>
      <el-divider content-position="left">表格数据</el-divider>
      <el-table :data="tableData" style="flex: auto">
        <el-table-column prop="sampleLabel" label="样本名称"/>
        <el-table-column prop="sampleLabelIndex" label="编号"/>
        <el-table-column prop="samples" label="样本数"/>
        <el-table-column prop="success" label="成功数"/>
        <el-table-column prop="errorPercentage" label="失败率"/>
        <el-table-column prop="average" label="平均耗时"/>
        <el-table-column prop="min" label="最小耗时"/>
        <el-table-column prop="max" label="最大耗时"/>
      </el-table>
      <el-divider content-position="left">历史轨迹</el-divider>
    </div>
  </div>
</template>

<script>
import {post} from "@/commons/request";
import {elapsedTimeDv, rpsDv, tpsDv, userDv} from "@/jmeter/components/others/reporter/index";
import ComponentContainer from "@/components/ComponentContainer";
import {Chart} from "@antv/g2";
import {Message} from "element-ui";

let timer;

let userChart;
let rpsChart;
let tpsChart;
let elapsedTimeChart;

function loading() {
  if (this.lifeCycle === "NEW") {
    this.loading = true;
    clearInterval(timer);
    timer = setInterval(() => this.doQuery(), this.$store.state.interval);
  } else if (this.lifeCycle === "RUNNABLE") {
    this.loading = false;
    clearInterval(timer);
    this.doDraw();
    timer = setInterval(() => this.doQuery(), this.$store.state.interval);
  } else if (this.lifeCycle === "TERMINAL") {
    this.loading = false;
    clearInterval(timer);
    this.doDraw();
  } else {
    Message.error("未知的生命周期：" + this.lifeCycle)
  }
}

export default {
  name: "Reporter",
  components: {ComponentContainer},
  props: {
    execId: String,
    process: Number,
    sampleLabel: String
  },
  data() {
    return {
      loading: false,
      tableData: [],
      startTime: undefined,
      endTime: undefined,
      before: undefined,
      currentTime: undefined,
      lifeCycle: undefined,
      tableSuffix: undefined
    }
  },
  watch: {
    'sampleLabel'() {
      if (!isNaN(this.$store.state.kv[this.sampleLabel])) {
        this.doQuery();
      }
    }
  },
  methods: {
    doQuery() {
      if (undefined !== this.execId) {
        post("/web/exec/record/detail", {execId: this.execId})
          .then(res => {
            this.lifeCycle = res.lifeCycle;
            this.tableSuffix = res.tableSuffix;
            this.startTime = res.startTime;
            this.before = res.before;
            this.currentTime = res.currentTime;
            this.endTime = res.endTime;
            loading.call(this);
          })
      }
    },
    doDraw() {
      post("/web/sampler/summariser", {
        "tableSuffix": this.tableSuffix,
        "execId": this.execId,
        "sampleLabel": this.sampleLabel,
        "startTime": this.lifeCycle === "TERMINAL" ? this.startTime : this.before,
        "endTime": this.lifeCycle === "TERMINAL" ? this.endTime : this.currentTime
      }).then(data => {
        if (Object.keys(data).length > 4) {
          this.tableData.pop();
          this.tableData.push(data);
          userDv.source(data.userList);
          userChart.changeData(userDv.rows);
          rpsDv.source(data.rpsList);
          rpsChart.changeData(rpsDv.rows);
          tpsDv.source(data.tpsList);
          tpsChart.changeData(tpsDv.rows);
          elapsedTimeDv.source(data.elapsedTimeList);
          elapsedTimeChart.changeData(elapsedTimeDv.rows);
        } else {
          userChart.changeData([]);
          tpsChart.changeData([]);
          rpsChart.changeData([]);
          elapsedTimeChart.changeData([]);
          this.tableData.pop();
        }
      })
    },
  },
  mounted() {
    userChart = new Chart({
      container: 'user',
      autoFit: true,
      defaultInteractions: ['tooltip', 'legend-filter'],
    });
    userChart.legend(false);
    userChart.animate(false);
    userChart.scale({
      ts: {
        type: 'timeCat',
        mask: 'mm/ss'
      },
      count: {
        min: 0,
        base: 10,
        type: 'log',
        nice: true
      }
    });
    userChart.line().position('ts*count').color('stat', ['#2fc25b', '#c22f3b']).shape('smooth');
    userChart.interaction('tooltip');
    userChart.interaction('sibling-tooltip');
    userChart.render();

    rpsChart = new Chart({
      container: 'rps',
      autoFit: true,
      defaultInteractions: ['tooltip', 'legend-filter'],
    });
    rpsChart.legend(false);
    rpsChart.animate(false);
    rpsChart.scale({
      ts: {
        type: 'timeCat',
        mask: 'mm/ss'
      },
      count: {
        min: 0,
        base: 10,
        type: 'log',
        nice: true
      }
    });
    rpsChart.line().position('ts*count').color('stat', ['#1890ff']).shape('smooth');
    rpsChart.interaction('tooltip');
    rpsChart.interaction('sibling-tooltip');
    rpsChart.render();


    tpsChart = new Chart({
      container: 'tps',
      autoFit: true,
      defaultInteractions: ['tooltip', 'legend-filter']
    });
    tpsChart.legend(false);
    tpsChart.animate(false);
    tpsChart.scale({
      ts: {
        type: 'timeCat',
        mask: 'mm/ss'
      },
      count: {
        min: 0,
        base: 10,
        type: 'log',
        nice: true
      }
    });
    tpsChart.line().position('ts*count').color('stat', ['#2fc25b', '#c22f3b']).shape('smooth');
    tpsChart.interaction('tooltip');
    tpsChart.interaction('sibling-tooltip');
    tpsChart.render();


    elapsedTimeChart = new Chart({
      container: 'elapsed-time',
      autoFit: true,
      defaultInteractions: ['tooltip', 'legend-filter']
    });
    elapsedTimeChart.legend(false);
    elapsedTimeChart.animate(false);
    elapsedTimeChart.scale({
      ts: {
        type: 'timeCat',
        mask: 'mm/ss'
      },
      count: {
        min: 0,
        base: 10,
        type: 'log',
        nice: true
      }
    });
    elapsedTimeChart.line().position('ts*count').color('stat', ['#2fc25b', '#c22f3b']).shape('smooth');
    elapsedTimeChart.interaction('tooltip');
    elapsedTimeChart.interaction('sibling-tooltip');
    elapsedTimeChart.render();
  }
}
</script>

<style scoped>
#container {
  height: 100%;
}

#canvas {
  height: 600px;
}

.metric {
  margin: 0 16px 0 16px;
  width: calc(100% - 32px);
  height: calc(100% - 16px);
}

.panel-items {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.panel-item {
  margin: 4px 0 4px 0;
  background-color: #ffffff;
  border: 1px solid rgba(36, 41, 46, .12);
  border-radius: 3px;
}

.panel-item-line-4 {
  height: 256px;
  min-width: 500px;
  width: calc((100% - 16px) / 2);
  justify-content: center;
  text-align: center;
}

.panel-item-line-drawer {
  height: calc(100% - 40px);
}

.panel-item-title {
  width: 100%;
  text-align: center;
  font-size: 14px;
  line-height: 40px;
}
</style>
